import { Fragment } from 'react'
import { Disclosure,} from '@headlessui/react'
import LogoWhite from '../assets/logos/videcloud-white.svg'
import { Link } from 'react-router-dom'
import { useAlert } from "../hooks/AlertHook";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Navbar() {
    const alerta = useAlert();

    return (
    <Disclosure as="nav" className="bg-vide-black static">
        <>
          <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              
              <div className="flex-1 flex items-center justify-center sm:items-stretch ">
                <div className="flex-shrink-0 flex items-center">
                  <Link to={alerta.homeLink}>
                  <img
                    className="block lg:hidden h-8 w-auto"
                    src={LogoWhite}
                    alt="Videcloud"
                  />
                  </Link>
                  <Link to={alerta.homeLink}>
                  <img
                    className="hidden lg:block h-7 w-auto"
                    src={LogoWhite}
                    alt="Videcloud"
                  />
                  </Link>
                </div>
                <div className="hidden sm:block sm:ml-6">
                  
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                {/* MENU USUARIO */}
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
            </div>
          </Disclosure.Panel>
        </>
    </Disclosure>
  )
}
